export default function CarIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 23 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.14817 13.8792V16.1909H0.910156V13.8792"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7146 13.8792V16.1909H17.4766V13.8792"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1757 6.94429L18.7806 1.3636C18.739 1.19683 18.6427 1.0488 18.5072 0.943031C18.3717 0.837266 18.2047 0.779847 18.0328 0.779907H4.59602C4.42419 0.779933 4.2573 0.837391 4.12187 0.943149C3.98645 1.04891 3.89025 1.1969 3.84859 1.3636L2.45312 6.94429"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.7149 13.8792H0.910156V8.80439C0.9102 8.60005 0.991411 8.40409 1.13593 8.25962L2.45125 6.94429H20.1738L21.4892 8.25962C21.6337 8.40409 21.7149 8.60005 21.7149 8.80439V13.8792Z"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.37848 11.5676C5.01682 11.5676 5.5343 11.0501 5.5343 10.4118C5.5343 9.77341 5.01682 9.25594 4.37848 9.25594C3.74014 9.25594 3.22266 9.77341 3.22266 10.4118C3.22266 11.0501 3.74014 11.5676 4.37848 11.5676Z"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2457 11.5676C18.884 11.5676 19.4015 11.0501 19.4015 10.4118C19.4015 9.77341 18.884 9.25594 18.2457 9.25594C17.6073 9.25594 17.0898 9.77341 17.0898 10.4118C17.0898 11.0501 17.6073 11.5676 18.2457 11.5676Z"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.38672 10.4117H13.2395"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
